import { Component } from '@angular/core';

@Component({
  selector: 'kt-app-stats-section',
  standalone: true,
  templateUrl: './stats-section.component.html',
  styleUrl: './stats-section.component.scss'
})
export class StatsSectionComponent {

}
